import { PayloadAction } from '@reduxjs/toolkit';

import { LayoutGridState, SetLayoutGridState } from '../types';

const updateLayoutGridStateField = ({
  key,
  state,
  action,
}: {
  key: keyof Omit<SetLayoutGridState, 'direction'>;
  state: LayoutGridState;
  action: PayloadAction<SetLayoutGridState>;
}) => {
  const payload = action.payload;
  if (!(key in payload)) return state[key];
  if (payload[key] === 'store-value') return state[key];
  return payload[key] ?? state[key];
};

export default updateLayoutGridStateField;
